/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterDto } from '../../models/center-dto';

export interface AdminCenterControllerFindAll$Params {

/**
 * 유저 아이디
 */
  userId?: string;

/**
 * 아동동 아이디
 */
  childId?: string;

/**
 * 소속 여부(유저 아이디가 있을 경우)
 */
  included?: boolean;

/**
 * 플랜
 */
  plans?: Array<'FREE' | 'PRO' | 'BASIC' | 'AI_PACKAGE'>;

/**
 * 대표관리자
 */
  ownerIds?: Array<string>;

/**
 * 관리 아동수
 */
  childCountStart?: number;

/**
 * 관리 아동수
 */
  childCountEnd?: number;

/**
 * 개업일
 */
  companyStartAtStart?: string;

/**
 * 개업일
 */
  companyStartAtEnd?: string;

/**
 * 등록일
 */
  createdAtStart?: string;

/**
 * 등록일
 */
  createdAtEnd?: string;

/**
 * 검색어
 */
  query?: string;
}

export function adminCenterControllerFindAll(http: HttpClient, rootUrl: string, params?: AdminCenterControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterDto>>> {
  const rb = new RequestBuilder(rootUrl, adminCenterControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('childId', params.childId, {});
    rb.query('included', params.included, {});
    rb.query('plans', params.plans, {});
    rb.query('ownerIds', params.ownerIds, {});
    rb.query('childCountStart', params.childCountStart, {});
    rb.query('childCountEnd', params.childCountEnd, {});
    rb.query('companyStartAtStart', params.companyStartAtStart, {});
    rb.query('companyStartAtEnd', params.companyStartAtEnd, {});
    rb.query('createdAtStart', params.createdAtStart, {});
    rb.query('createdAtEnd', params.createdAtEnd, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterDto>>;
    })
  );
}

adminCenterControllerFindAll.PATH = '/api/center/admin';
